// extracted by mini-css-extract-plugin
export var messageSideLeft = "_os-1";
export var messageSideRight = "_os-2";
export var subscribeToBackInStockBubbleContainer = "_os-0";